import { TelegramAccountBranding } from '../../shared/types/TelegramAccountBranding'
import { TelegramAccountBrandingEntity } from '../../domain/entities/TelegramAccountBranding'

export type TelegramAccountBrandingAPIModel = TelegramAccountBranding

export const mapApiToEntity = (api: TelegramAccountBrandingAPIModel): TelegramAccountBrandingEntity =>
  TelegramAccountBrandingEntity.create({
    telegramAccountUUID: api.telegramAccountUUID,
    firstName: api.firstName ?? '',
    lastName: api.lastName ?? '',
    about: api.about ?? '',
    avatarUrl: api.avatarUrl ?? null,
    loadedFromCache: Boolean(api.loadedFromCache),
  })
